<!-- Features Section -->
<section class="features-section" id="services" [ngClass]="isStandalonePage ? '' : 'padding'">
  <app-footer-header *ngIf="isStandalonePage"></app-footer-header>

  <div class="container" [ngClass]="isStandalonePage ? 'padding' : ''">
    <div class="section-header">
      <h2 class="section-title animate-slide-up">Why to choose <span class="gradient-text">HPS Life</span>?</h2>
    </div>
    <div class="testimonial-cards-grid">
      <div class="cards-container animate-slide-left">
        <!-- Card 1 -->
        <div class="testimonial-card card-1 animate-on-scroll" data-delay="0.1">
          <div class="card-top-section">
            <div class="card-header">
              <h3 class="card-title">High Acceptance Rates</h3>
            </div>
            <div class="card-illustration">
              <div class="illustration-container success-rate-illustration">
                <img src="../../../../../assets/images/feature-1.svg" alt="" width="80" height="80"/>
              </div>
            </div>
          </div>
          <div class="card-content animate-slide-up">
            <div class="card-features">
              <div class="feature-item">
                <svg class="tick-icon" width="20" height="20" viewBox="0 0 24 24" fill="none">
                  <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" stroke="currentColor" stroke-width="2"
                    stroke-linecap="round" stroke-linejoin="round" />
                </svg>
                90% quote success rate
              </div>
              <div class="feature-item">
                <svg class="tick-icon" width="20" height="20" viewBox="0 0 24 24" fill="none">
                  <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" stroke="currentColor" stroke-width="2"
                    stroke-linecap="round" stroke-linejoin="round" />
                </svg>
                Fast approval process
              </div>
              <div class="feature-item">
                <svg class="tick-icon" width="20" height="20" viewBox="0 0 24 24" fill="none">
                  <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" stroke="currentColor" stroke-width="2"
                    stroke-linecap="round" stroke-linejoin="round" />
                </svg>
                Streamlined underwriting
              </div>
            </div>
          </div>
        </div>

        <!-- Card 2 -->
        <div class="testimonial-card card-2 animate-on-scroll" data-delay="0.2">
          <div class="card-top-section">
            <div class="card-header">
              <h3 class="card-title">Affordable Premiums</h3>
            </div>
            <div class="card-illustration">
              <div class="illustration-container pricing-illustration">
                <img src="../../../../../assets/images/feature-2.svg" width="80" height="80" alt="" />

              </div>
            </div>
          </div>
          <div class="card-content animate-slide-up">
            <div class="card-features">
              <div class="feature-item">
                <svg class="tick-icon" width="20" height="20" viewBox="0 0 24 24" fill="none">
                  <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" stroke="currentColor" stroke-width="2"
                    stroke-linecap="round" stroke-linejoin="round" />
                </svg>
                Competitive pricing
              </div>
              <div class="feature-item">
                <svg class="tick-icon" width="20" height="20" viewBox="0 0 24 24" fill="none">
                  <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" stroke="currentColor" stroke-width="2"
                    stroke-linecap="round" stroke-linejoin="round" />
                </svg>
                Comprehensive coverage
              </div>
              <div class="feature-item">
                <svg class="tick-icon" width="20" height="20" viewBox="0 0 24 24" fill="none">
                  <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" stroke="currentColor" stroke-width="2"
                    stroke-linecap="round" stroke-linejoin="round" />
                </svg>
                Value for money
              </div>
            </div>
          </div>
        </div>

        <!-- Card 3 -->
        <div class="testimonial-card card-3 animate-on-scroll" data-delay="0.3">
          <div class="card-top-section">
            <div class="card-header">
              <h3 class="card-title">Accessible & Informed</h3>
            </div>
            <div class="card-illustration">
              <div class="illustration-container support-illustration">
                <img src="../../../../../assets/images/feature-3.svg" width="80" height="80" alt="" />

              </div>
            </div>
          </div>
          <div class="card-content animate-slide-up">
            <div class="card-features">
              <div class="feature-item">
                <svg class="tick-icon" width="20" height="20" viewBox="0 0 24 24" fill="none">
                  <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" stroke="currentColor" stroke-width="2"
                    stroke-linecap="round" stroke-linejoin="round" />
                </svg>
                Easy policy access
              </div>
              <div class="feature-item">
                <svg class="tick-icon" width="20" height="20" viewBox="0 0 24 24" fill="none">
                  <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" stroke="currentColor" stroke-width="2"
                    stroke-linecap="round" stroke-linejoin="round" />
                </svg>
                24/7 support
              </div>
              <div class="feature-item">
                <svg class="tick-icon" width="20" height="20" viewBox="0 0 24 24" fill="none">
                  <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" stroke="currentColor" stroke-width="2"
                    stroke-linecap="round" stroke-linejoin="round" />
                </svg>
                Clear information
              </div>
            </div>
          </div>
        </div>

        <!-- Card 4 -->
        <div class="testimonial-card card-4 animate-on-scroll" data-delay="0.4">
          <div class="card-top-section">
            <div class="card-header">
              <h3 class="card-title">Doctor-led Underwriting</h3>
            </div>
            <div class="card-illustration">
              <div class="illustration-container medical-illustration">
                <img src="../../../../../assets/images/feature-4.svg" width="80" height="80" alt="" />

              </div>
            </div>
          </div>
          <div class="card-content animate-slide-up">
            <div class="card-features">
              <div class="feature-item">
                <svg class="tick-icon" width="20" height="20" viewBox="0 0 24 24" fill="none">
                  <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" stroke="currentColor" stroke-width="2"
                    stroke-linecap="round" stroke-linejoin="round" />
                </svg>
                Medical expertise
              </div>
              <div class="feature-item">
                <svg class="tick-icon" width="20" height="20" viewBox="0 0 24 24" fill="none">
                  <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" stroke="currentColor" stroke-width="2"
                    stroke-linecap="round" stroke-linejoin="round" />
                </svg>
                Complex condition handling
              </div>
              <div class="feature-item">
                <svg class="tick-icon" width="20" height="20" viewBox="0 0 24 24" fill="none">
                  <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" stroke="currentColor" stroke-width="2"
                    stroke-linecap="round" stroke-linejoin="round" />
                </svg>
                Personalized assessment
              </div>
            </div>
          </div>
        </div>

        <!-- Card 5 -->
        <div class="testimonial-card card-5 animate-on-scroll" data-delay="0.5">
          <div class="card-top-section">
            <div class="card-header">
              <h3 class="card-title">Choice of Cover Terms</h3>
            </div>
            <div class="card-illustration">
              <div class="illustration-container terms-illustration">
                <img src="../../../../../assets/images/feature-5.svg" width="80" height="80" alt="" />

              </div>
            </div>
          </div>
          <div class="card-content animate-slide-up">
            <div class="card-features">
              <div class="feature-item">
                <svg class="tick-icon" width="20" height="20" viewBox="0 0 24 24" fill="none">
                  <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" stroke="currentColor" stroke-width="2"
                    stroke-linecap="round" stroke-linejoin="round" />
                </svg>
                Level term 1-50 years
              </div>
              <div class="feature-item">
                <svg class="tick-icon" width="20" height="20" viewBox="0 0 24 24" fill="none">
                  <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" stroke="currentColor" stroke-width="2"
                    stroke-linecap="round" stroke-linejoin="round" />
                </svg>
                Decreasing term 5-50 years
              </div>
              <div class="feature-item">
                <svg class="tick-icon" width="20" height="20" viewBox="0 0 24 24" fill="none">
                  <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" stroke="currentColor" stroke-width="2"
                    stroke-linecap="round" stroke-linejoin="round" />
                </svg>
                Max entry age 75
              </div>
            </div>
          </div>
        </div>

        <!-- Card 6 -->
        <div class="testimonial-card card-6 animate-on-scroll" data-delay="0.6">
          <div class="card-top-section">
            <div class="card-header">
              <h3 class="card-title">Customer Focused</h3>
            </div>
            <div class="card-illustration">
              <div class="illustration-container customer-illustration">
                <img src="../../../../../assets/images/feature-6.svg" width="80" height="80" alt="" />

              </div>
            </div>
          </div>
          <div class="card-content animate-slide-up">
            <div class="card-features">
              <div class="feature-item">
                <svg class="tick-icon" width="20" height="20" viewBox="0 0 24 24" fill="none">
                  <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" stroke="currentColor" stroke-width="2"
                    stroke-linecap="round" stroke-linejoin="round" />
                </svg>
                Dedicated portal
              </div>
              <div class="feature-item">
                <svg class="tick-icon" width="20" height="20" viewBox="0 0 24 24" fill="none">
                  <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" stroke="currentColor" stroke-width="2"
                    stroke-linecap="round" stroke-linejoin="round" />
                </svg>
                Document access
              </div>
              <div class="feature-item">
                <svg class="tick-icon" width="20" height="20" viewBox="0 0 24 24" fill="none">
                  <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" stroke="currentColor" stroke-width="2"
                    stroke-linecap="round" stroke-linejoin="round" />
                </svg>
                Payment management
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <app-footer *ngIf="isStandalonePage"></app-footer>

</section>